import { AnalyticsPlatforms } from '@dni-analysis'
import { useAnalytics } from '@dni-analysis'
import { useDialog } from '@dni-hooks/useDialog'
import { Dialog, DialogActions, DialogContent } from '@fortune-ui'
import { useApiECommerceCancelSubscription } from '@hooks-api/ec/useApiECommerceCancelSubscription'
import { mutateAllECommerceOrders } from '@hooks-api/ec/useApiECommerceOrders'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { Trans, useTranslation } from 'react-i18next'
import { CANCEl_SUBSCRIPTION_DIALOG_KEY, SERVER_ERROR_DIALOG_KEY } from '../constants/dialogKey'

export interface DialogCancelSubscriptionProps {
  fortuneOrderId: string
}

interface DialogCancelSubscriptionComponentProps extends DialogCancelSubscriptionProps {
  onClose: () => void
}

const DialogCancelSubscriptionComponent = ({ onClose, fortuneOrderId }: DialogCancelSubscriptionComponentProps) => {
  const { openDialog: openServerErrorDialog } = useDialog(SERVER_ERROR_DIALOG_KEY)
  const { t } = useTranslation()
  const { trigger, isMutating } = useApiECommerceCancelSubscription()
  const { sendEvent } = useAnalytics({ defaultPlatforms: [AnalyticsPlatforms.GA4] })
  const handleClickCancelSubscription = async () => {
    sendEvent({
      eventName: 'click_cancel_subscription_btn',
      eventParams: {},
    })
    try {
      await trigger({ id: fortuneOrderId })
      onClose()
    }
    catch (e) {
      console.error('handleClickCancelSubscription', e)
      onClose()
      openServerErrorDialog()
    }
    finally {
      mutateAllECommerceOrders?.()
    }
  }
  return (
    <Box p={4}>
      <Text align="center" variant="h4">
        {t('wpOrder.cancelAutoRenewButton', { defaultValue: '取消自動購買' })}
      </Text>
      <DialogContent sx={{ p: 0, m: '8px 0 16px 0' }}>
        <Text align="center">
          <Trans
            i18nKey="wpOrder.cancelAutoRenewDialogContent"
            components={{
              Br: <div />,
            }}
          />
        </Text>
      </DialogContent>
      <DialogActions sx={{ p: 0 }}>
        <HStack gap={2} flexWrap="nowrap" width="100%">
          <Button loading={isMutating} onClick={onClose} fullWidth variant="outlined">{t('wpOrder.cancel')}</Button>
          <Button loading={isMutating} fullWidth variant="filled" onClick={handleClickCancelSubscription}>{t('wpOrder.submit')}</Button>
        </HStack>
      </DialogActions>
    </Box>
  )
}

export function DialogCancelSubscription() {
  const { open, closeDialog, fortuneOrderId: fortuneProductId } = useDialog<DialogCancelSubscriptionProps>(CANCEl_SUBSCRIPTION_DIALOG_KEY)

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={closeDialog}
      disablePortal
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '320px',
          borderRadius: '8px',
        },
      }}
    >
      <DialogCancelSubscriptionComponent onClose={closeDialog} fortuneOrderId={fortuneProductId} />
    </Dialog>
  )
}
